import { useState } from 'react';
import BugFilled from '@ant-design/icons/BugFilled';
import { Flex, Text } from '@distribusion/portal-lib/components';
import { Button, Modal, Switch } from 'antd';
import { FeatureFlagEnum, featureFlags, FF_LOCAL_STORAGE_KEY } from 'lib/feature-flags';
import { useTranslation } from 'lib/translation';

export const FeatureFlagsSwitch = () => {
  const { t } = useTranslation();
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [featureFlagsState, setFeatureFlagsState] = useState(featureFlags);

  const onCloseModal = () => {
    setFeatureFlagsState(featureFlags);
    setIsModalOpened(false);
  };

  const onApplyClick = () => {
    localStorage.setItem(FF_LOCAL_STORAGE_KEY, JSON.stringify(featureFlagsState));
    window.location.reload();
  };

  return (
    <>
      <Button
        type="text"
        icon={<BugFilled />}
        title="Feature flags"
        onClick={() => setIsModalOpened(true)}
      />
      <Modal
        width={450}
        open={isModalOpened}
        title="Feature flags"
        okText={t('common:filter_form.buttons.apply')}
        onOk={onApplyClick}
        onCancel={onCloseModal}
      >
        <Flex vertical gap="middle">
          {Object.values(FeatureFlagEnum).map((flag) => (
            <Flex key={flag} gap="middle">
              <Switch
                size="default"
                checked={featureFlagsState[flag]}
                onChange={(checked) => {
                  setFeatureFlagsState((prev) => ({
                    ...prev,
                    [flag]: checked,
                  }));
                }}
              />
              <Text>{flag}</Text>
            </Flex>
          ))}
        </Flex>
      </Modal>
    </>
  );
};
